import { Link } from 'react-router-dom';

const ProductsCTA = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-[#F8FBF6] rounded-2xl p-10 md:p-14 text-center">
          <h3 className="text-xl md:text-2xl font-bold text-[#89B56B] mb-4">
            業務に合わせた開発・カスタマイズ
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed mb-8 max-w-2xl mx-auto">
            社内ワークフローに合わせた機能追加、画面・ブランドの調整、導入支援なども承ります。
            <br />
            「こういうツールが欲しい」というご相談も歓迎です。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-[#89B56B] text-white text-sm font-bold rounded-lg hover:bg-[#5DAA68] transition-colors whitespace-nowrap"
            >
              お問い合わせ
            </Link>
            <Link
              to="/service"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-white text-[#5DAA68] border border-[#5DAA68] text-sm font-bold rounded-lg hover:bg-[#89B56B] hover:text-white hover:border-[#89B56B] transition-colors whitespace-nowrap"
            >
              事業案内を見る
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsCTA;